var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.717,
    height: 26,
    viewBox: "0 0 29.717 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert_Icon",
    transform: "translate(-711 -160.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Triangle",
    d: "M27,26H2.7A2.677,2.677,0,0,1,.347,24.643a2.623,2.623,0,0,1,.017-2.662L12.516,1.329a2.717,2.717,0,0,1,4.672,0L29.339,21.982a2.621,2.621,0,0,1,.016,2.66A2.677,2.677,0,0,1,27,26Z",
    transform: "translate(711.007 160.5)",
    fill: "#ff9a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclamation",
    d: "M2.389,1.738l.267-9.152H.826l.267,9.152ZM1.741,5.647A1.107,1.107,0,0,0,2.866,4.465,1.1,1.1,0,0,0,1.741,3.282,1.118,1.118,0,0,0,.616,4.465,1.118,1.118,0,0,0,1.741,5.647Z",
    transform: "translate(724.251 176.625)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/Alert_Icon.e152c92b.svg";
export { ForwardRef as ReactComponent };